/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface EmailDescription
 */
export interface EmailDescription {
  /**
   *
   * @type {Array<string>}
   * @memberof EmailDescription
   */
  addresses: Array<string>;
  /**
   *
   * @type {string}
   * @memberof EmailDescription
   */
  subject: string;
  /**
   *
   * @type {string}
   * @memberof EmailDescription
   */
  emailBody: string;
  /**
   *
   * @type {string}
   * @memberof EmailDescription
   */
  fromAddress?: string | null;
  /**
   *
   * @type {Array<string>}
   * @memberof EmailDescription
   */
  ccAddresses?: Array<string> | null;
}

/**
 * Check if a given object implements the EmailDescription interface.
 */
export function instanceOfEmailDescription(
  value: object,
): value is EmailDescription {
  if (!("addresses" in value) || value["addresses"] === undefined) return false;
  if (!("subject" in value) || value["subject"] === undefined) return false;
  if (!("emailBody" in value) || value["emailBody"] === undefined) return false;
  return true;
}

export function EmailDescriptionFromJSON(json: any): EmailDescription {
  return EmailDescriptionFromJSONTyped(json, false);
}

export function EmailDescriptionFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): EmailDescription {
  if (json == null) {
    return json;
  }
  return {
    addresses: json["addresses"],
    subject: json["subject"],
    emailBody: json["emailBody"],
    fromAddress: json["fromAddress"] == null ? undefined : json["fromAddress"],
    ccAddresses: json["ccAddresses"] == null ? undefined : json["ccAddresses"],
  };
}

export function EmailDescriptionToJSON(json: any): EmailDescription {
  return EmailDescriptionToJSONTyped(json, false);
}

export function EmailDescriptionToJSONTyped(
  value?: EmailDescription | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    addresses: value["addresses"],
    subject: value["subject"],
    emailBody: value["emailBody"],
    fromAddress: value["fromAddress"],
    ccAddresses: value["ccAddresses"],
  };
}
